import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { IconLock, IconCheck, IconRocket } from '@tabler/icons-react';
import './UpgradeModal.css';

const UpgradeModal = ({ show, onClose, featureName, featureDescription, featureIcon: FeatureIcon, featureGradient }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/my-plan');
  };

  return (
    <Modal show={show} onHide={onClose} centered className="upgrade-modal" size="sm">
      <Modal.Body>
        <div className="upgrade-modal__content">
          <div
            className="upgrade-modal__icon-wrapper"
            style={{ background: featureGradient || 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}
          >
            {FeatureIcon && <FeatureIcon size={28} color="#fff" stroke={1.5} />}
            <div className="upgrade-modal__lock-badge">
              <IconLock size={12} stroke={2.5} />
            </div>
          </div>

          <div className="upgrade-modal__title">Recurso Premium</div>

          <div className="upgrade-modal__description">
            <strong>{featureName}</strong>
            {featureDescription && (
              <>
                <br />
                {featureDescription}
              </>
            )}
          </div>

          <div className="upgrade-modal__plans">
            <div className="upgrade-modal__plan-tag">
              <IconCheck size={16} /> Founder
            </div>
            <div className="upgrade-modal__plan-tag">
              <IconCheck size={16} /> Business
            </div>
          </div>

          <div className="upgrade-modal__actions">
            <button className="upgrade-modal__btn-close" onClick={onClose}>
              Fechar
            </button>
            <button className="upgrade-modal__btn-upgrade" onClick={handleUpgrade}>
              <IconRocket size={16} />
              Ver Planos
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeModal;
